import { render, staticRenderFns } from "./NavigationBarNotificationsMenu.vue?vue&type=template&id=24b9b583&scoped=true&"
import script from "./NavigationBarNotificationsMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationBarNotificationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarNotificationsMenu.vue?vue&type=style&index=0&id=24b9b583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9b583",
  null
  
)

export default component.exports